import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { CheckCircle2 } from 'lucide-react';
const audiences = [{
  title: 'Mamás y papás agotados',
  desc: 'Que llevan meses o años buscando estrategias y no encuentran algo concreto, completo y aplicable desde hoy.'
}, {
  title: 'Familias con diagnóstico reciente',
  desc: 'Que acaban de recibir el diagnóstico y no saben por dónde empezar ni qué viene ahora.'
}, {
  title: 'Familias en conflicto con el sistema',
  desc: 'Que tienen problemas con el colegio o la obra social y necesitan saber exactamente cuáles son sus derechos y cómo ejercerlos.',
  badge: 'NUEVO'
}, {
  title: 'Padres de pre-adolescentes con TDAH',
  desc: "Que sienten que su hijo de 11, 12 o 13 años 'empeoró' y no encuentran recursos para esta etapa específica."
}];
export function Audience() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <SectionHeader title="¿PARA QUIÉN ES?" subtitle="Diseñado para vos si querés dejar de apagar incendios y empezar a ver cambios reales" data-id="element-20" />

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto mb-8 md:mb-12" data-id="element-21">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#FBF7F0] p-5 md:p-8 rounded-2xl border border-[#1E2A4A]/10 relative overflow-hidden" data-id="element-22">
              {item.badge && <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-[#E76F51] text-white text-[10px] md:text-xs font-bold px-2 py-1 rounded uppercase tracking-wide" data-id="element-23">
                  {item.badge}
                </div>}
              <div className="flex items-start gap-3 md:gap-4" data-id="element-24">
                <CheckCircle2 className="text-[#8A9A86] shrink-0 mt-0.5 md:mt-1 w-5 h-5 md:w-6 md:h-6" data-id="element-25" />
                <div data-id="element-26">
                  <h3 className="font-bold text-[#1E2A4A] text-lg md:text-xl mb-1 md:mb-2 pr-12" data-id="element-27">
                    {item.title}
                  </h3>
                  <p className="text-[#1E2A4A]/80 text-sm md:text-base leading-relaxed" data-id="element-28">
                    {item.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center px-4" data-id="element-29">
          <a href="#precios" onClick={e => {
          e.preventDefault();
          document.getElementById('precios')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center gap-2 text-[#E76F51] text-sm md:text-base font-semibold hover:text-[#d66245] transition-colors" data-id="element-30">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía →
          </a>
        </div>
      </div>
    </section>;
}